<ion-item lines="full">
  <ion-title class="ion-padding-vertical ion-padding-start"
    ><b>{{ 'device_addDevice' | translate }}</b></ion-title
  >
  <ion-buttons slot="end">
    <ion-button (click)="dismiss('cancel')"
      ><ion-icon name="close-outline"></ion-icon
    ></ion-button>
  </ion-buttons>
</ion-item>
<div class="ion-margin-bottom">
  <form [formGroup]="deviceForm" novalidate>
    <ion-grid class="ion-margin-top">
      <ion-row>
        <ion-col>
          <ion-label class="ion-padding panel-label-text">
            {{ 'device_serialNumber' | translate }}
          </ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="ion-no-padding ion-padding-horizontal">
            <ion-input
              placeholder="{{ 'device_serialNumber' | translate }}"
              formControlName="serial_number"
              [ngClass]="
                formHelper().isFieldValidCss(
                  'serial_number',
                  isFormSubmitAttempted()
                )
              "
              required
            ></ion-input>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-label
            class="ion-no-padding ion-padding-horizontal panel-label-text"
          >
            {{ 'device_activationKey' | translate }}
          </ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="ion-padding-horizontal">
            <ion-input
              placeholder="{{ 'device_activationKey' | translate }}"
              formControlName="activation_code"
              [ngClass]="
                formHelper().isFieldValidCss(
                  'activation_code',
                  isFormSubmitAttempted()
                )
              "
              required
            ></ion-input>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-label
            class="ion-no-padding ion-padding-horizontal panel-label-text"
          >
            {{ 'device_timezone' | translate }}
          </ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="ion-padding-horizontal">
            <ion-item
              [ngClass]="
                formHelper().isFieldValidCss(
                  'timezone',
                  isFormSubmitAttempted()
                )
              "
              class="position-relative"
            >
              <ion-label>&nbsp;</ion-label>
              @if (_timezoneData()) {
                <ionic-selectable
                  formControlName="timezone"
                  [shouldFocusSearchbar]="true"
                  [items]="_timezoneData()"
                  itemValueField="id"
                  itemTextField="name"
                  [canSearch]="true"
                >
                </ionic-selectable>
              }
            </ion-item>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</div>
<ion-footer class="ion-margin-top">
  <div class="ion-text-center ion-padding">
    <ion-button
      id="showmoddel"
      color="primary"
      class="ion-align-self-center"
      (click)="dismiss('cancel')"
    >
      <small>{{ 'general_cancel' | translate }}</small></ion-button
    >
    <ion-button
      type="submit"
      id="showsuccessmoddel"
      color="primary"
      (click)="onSubmitDeviceAdd()"
      class="ion-align-self-center"
      [disabled]="!deviceForm.valid"
      ><small>{{ 'general_ok' | translate }}</small>
    </ion-button>
  </div>
</ion-footer>
